module.exports = __webpack_public_path__ + "img/picto_wrong.d375cdd5.png";